import { render, staticRenderFns } from "./warning-2.vue?vue&type=template&id=2fdd86d1&"
import script from "./warning-2.vue?vue&type=script&lang=js&"
export * from "./warning-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports